import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Colors } from 'styles/colors'

export const TeamMembersTitle = styled(Typography)`
  color: ${Colors.PINK};
  margin-bottom: 0;
`
